<template>
  <div class="container mt-5" style="min-height: 87%">
    <h4 class="text-center">
      Accéder à mon espace personnel <br>
      {{ hospitalName }}
    </h4>
    <div class="row mt-1 justify-content-center">
      <connection-choice />
    
      <div class="col-md-6 mr-3 mt-3 basics-10-bg" style="border: 1px solid rgba(0,0,0,.1);">
        <h5 class="text-center pt-3">
          Comment se connecter ?
        </h5>
        <hr class="ml-3 mr-3">
        <div class="pl-3 pr-2">
          <div>
            <span class="subtitle pl-3 pr-2">Se connecter avec FranceConnect</span>
            <ul class="mt-0 pl-5 mr-4 mb-3">
              <li>Connectez vous avec FranceConnect avec vos identifiants habituels.</li>
              <li>Votre Identifiant Permanent Patient vous sera ensuite demandé.</li>
            </ul>
          </div>

          <div>
            <span class="subtitle pl-3 pr-2">Se connecter sans FranceConnect</span>
            <ul class="mt-0 pl-5 mr-4 mb-3">
              <li>Vous pouvez envoyer un mail à <b> {{ hospitalMail }} </b> en renseignant votre nom, prénom, date de naissance et votre Identifiant Permanent Patient (IPP).</li>
              <li>L’hôpital vous transmettra alors un lien à usage unique sous une trentaine de jours pour vous connecter.</li>
              <li>Votre Identifiant Permanent Patient vous sera ensuite demandé lors de la deuxième étape de connexion.</li>
            </ul>
          </div>

          <div>
            <span class="subtitle pl-3 pr-2">Où trouver mon Identifiant Permanent Patient ?</span>
            <p class="text mb-0 pt-0 pl-3 pr-2">
              Vous pouvez retrouver votre Identifiant Permanent Patient :
            </p>
            <ul class="mt-0 pl-5 mr-4 mb-3">
              <li>sur vos comptes rendus d'examens</li>
              <li>sur vos comptes rendus d'hospitalisation</li>
              <li>sur vos documents de facturation : relevés, récapitulatifs et factures</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import AuthService from '../../services/auth.service';
import ConnectionChoice from './ConnectionChoice.vue';

export default {
  name: 'Login',
  components: { ConnectionChoice },
  data() {
      return {
          hospitalName: process.env.VUE_APP_HOSPITAL_NAME,
          hospitalMail: process.env.VUE_APP_HOSPITAL_MAIL
      };
  },

  mounted() {
    sessionStorage.removeItem("isMagicToken");
    if (AuthService.isAuthenticated() || AuthService.isIdentified()) {
      AuthService.logout(true);
    }
  },
};
</script>

<style>
.subtitle {
    font-family: Avenir Next;
    font-size: 18px;
    font-weight: 500;
    line-height: 26px;
    letter-spacing: -0.4000000059604645px;
    text-align: left;
}

li, .text {
    font-family: Avenir Next;
    font-size: 16px;
    font-weight: 400;
    line-height: 23px;
    letter-spacing: -0.30000001192092896px;
    text-align: left;
    color:#4B535E
}

</style>
